<!-- Template -->
<template>
  <div class="selection-calendar-year-box">
    <span
      class="selection-calendar-year-box__icon-left"
      :class="{ 'selection-calendar-year-box__icon-left__disabled': props.leftArrowDisabled }"
      role="button"
      tabindex="0"
      @click="
        () => {
          props.leftArrowDisabled ? null : $emit('leftArrowPressed')
        }
      "
      @keydown.enter="
        () => {
          props.leftArrowDisabled ? null : $emit('leftArrowPressed')
        }
      "
      @keydown.space="
        () => {
          props.leftArrowDisabled ? null : $emit('leftArrowPressed')
        }
      "
    >
      <IconChevronLeft
    /></span>
    <span class="selection-calendar-year-box__label">{{ props.label }} </span>
    <span
      class="selection-calendar-year-box__icon-right"
      :class="{ 'selection-calendar-year-box__icon-right__disabled': props.rightArrowDisabled }"
      role="button"
      tabindex="0"
      @click="
        () => {
          props.rightArrowDisabled ? null : $emit('rightArrowPressed')
        }
      "
      @keydown.enter="
        () => {
          props.rightArrowDisabled ? null : $emit('rightArrowPressed')
        }
      "
      @keydown.space="
        () => {
          props.rightArrowDisabled ? null : $emit('rightArrowPressed')
        }
      "
    >
      <IconChevronRight
    /></span>
  </div>
</template>
<!-- Script -->
<script lang="ts" setup>
import IconChevronRight from '@/design-system/assets/icons/IconChevronRight.vue'
import IconChevronLeft from '@/design-system/assets/icons/IconChevronLeft.vue'

const props = defineProps({
  leftArrowDisabled: {
    required: true,
    type: Boolean
  },
  rightArrowDisabled: {
    required: true,
    type: Boolean
  },
  label: {
    required: false,
    type: String,
    default: ''
  }
})

defineEmits<{
  (event: 'leftArrowPressed'): void
  (event: 'rightArrowPressed'): void
}>()
</script>
<!-- Style -->
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
.selection-calendar-year-box {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: variables.$gap-xlarge;
  justify-content: center;
  &__icon-left {
    color: variables.$color-primary;
    cursor: pointer;
    display: flex;
    &__disabled {
      color: variables.$color-disabled;
      cursor: not-allowed;
    }
  }
  &__label {
    @include font-mixins.desktop-regular-h4;
  }
  &__icon-right {
    color: variables.$color-primary;
    cursor: pointer;
    display: flex;
    &__disabled {
      color: variables.$color-disabled;
      cursor: not-allowed;
    }
  }
}
</style>
